import { render, staticRenderFns } from "./MatchFieldKey.vue?vue&type=template&id=2b8e9331"
import script from "./MatchFieldKey.vue?vue&type=script&lang=js"
export * from "./MatchFieldKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports